export default __webpack_public_path__ + "static/media/right-click.aa6c17ce.svg";